export const DEVICE_KIND = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  TABLET: 'TABLET',
  MEDIUM: 'MEDIUM',
};
export const VALIDATE_SMS_ERRORS = {
  457: 'El código no es válido. Por favor, solicita un código nuevo.',
  456: 'El código no es correcto. Por favor, inténtalo de nuevo.',
  default: '',
};
export const VALIDATE_SMS_ERRORS_IN_FORM = {
  461: 'El medio de contacto no es válido. Por favor, utiliza uno diferente.',
  409: 'El medio de contacto que has introducido ya está en uso. Por favor, utiliza uno diferente.',
  default: '',
};
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
export const RECAPTCHA_KEY =
  currentEnv !== 'prod'
    ? '6Lcp0mQqAAAAAIH8GNU6awyPIdEKQUt41zrkyp15'
    : '6LcJ4YYqAAAAACS_tkIW80N7lnhoK8c81AGxubSX';

export const LOGIN_URL = "https://www.movistar.es/auth/login";
export const HOME_URL = "https://www.movistar.es/misc/auth/home";

export const CLIENT_TYPE = {
  CLIENT: 'client',
  NO_CLIENT: 'no_client',
  SOFT_CLIENT: 'soft_client',
};
export const SESSION_STORAGE_PRODUCT_INFO = 'sessionStorageProductInfo';

export const COOKIES = {
  SETH_REG_ID: 'seth-reg-id',
  SETH_REG_CHECKSUM: 'seth-reg-checksum',
  SETH_REG_WB: 'seth-reg-wb', // BOOL estamos en webview
  SETH_REG_URL: 'seth-reg-url', // URL INICIO FLUJO
  SETH_REG_OP: 'seth-reg-op', // OP FINAL REGIS O REG
};
